// Mirrors the backend's get_user_short_name (users/utils.py) -- "First Last" -> "First L" --
// so a raw full name can be matched against agent options, which are already shortened this way.
export const getUserShortName = (fullName: string): string => {
  const [firstName, secondName] = fullName.trim().split(/\s+/).filter(Boolean);

  if (secondName) {
    return `${firstName} ${secondName[0]}`;
  }

  return fullName;
};
